import { useQuery } from '@apollo/client'

import { GQL_QUERY_FAQ_COLLECTION } from '@entities/Faq/model/queries'
import type {
  FaqCollectionQuery,
  FaqCollectionQueryVariables,
  FaqItem,
} from '@entities/Faq/model/types'

interface UseFaqCollectionProps {
  id?: string;
  code?: string;
}

/*
  Reads an active FAQ collection by id or code. Items are returned ordered by
  `order`; the backend already filters out inactive ones.
*/
export function useFaqCollection ({ id, code }: UseFaqCollectionProps) {
  const { data, loading, error } = useQuery<FaqCollectionQuery, FaqCollectionQueryVariables>(
    GQL_QUERY_FAQ_COLLECTION,
    {
      variables: {
        id: id ?? null,
        code: code ?? null,
      },
      fetchPolicy: 'cache-first',
      skip: !id && !code,
    },
  )

  const faqCollection = data?.faqCollection ?? null

  const items: FaqItem[] = [ ...(faqCollection?.items ?? []) ]
    .filter((item) => Boolean(item?.question))
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))

  return {
    faqCollection,
    items,
    loading,
    error,
  }
}
